



























import { Component, Prop, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import LoadingIndicator from '@/views/common/LoadingIndicator.vue';
import AddressList from '@/views/account/user/AddressList.vue';
import { AddressDto, OrderDto, ShoppingCartItemGroupDto } from '@/api';
import ShowMorePagination from '@/views/common/ShowMorePagination.vue';
import OrderHistoryStore from '@/stores/order/order-history.store';
import DeliverySection from '@/views/order-checkout/common/DeliverySection.vue';
import OrderGroup from '@/views/product/widgets/OrderGroup.vue';
import Big from 'big.js';
import { PriceFormatter } from '@/util/PriceFormatter';
import Routes from '@/util/Routes';
import OrderDetailView from '@/views/common/OrderDetailView.vue';

@Component({
  components: {OrderGroup, ShowMorePagination, AddressList, LoadingIndicator, DeliverySection, OrderDetailView},
})
export default class UserOrderDetail extends Vue {
  public orderHistoryStore = getModule(OrderHistoryStore, this.$store);

  @Prop({required: true})
  private orderId!: string;

  public loading = true;

  public async mounted() {
    await this.orderHistoryStore.fetchOrder(this.orderId);
    this.loading = false;
  }

  get currentOrder(): OrderDto | null {
    return this.orderHistoryStore.currentSelectedOrder;
  }

  get orderItemGroups(): ShoppingCartItemGroupDto[] {
    return this.currentOrder?.orderItemGroups ?? [];
  }

  get billingAddress(): AddressDto | undefined {
    return this.currentOrder?.billingAddress;
  }

  get deliveryAddress(): AddressDto | undefined {
    return this.currentOrder?.deliveryAddress;
  }

  get currentEmail(): string {
    return this.currentOrder?.email ?? '';
  }

  get paymentMethod() {
    return this.currentOrder?.paymentMethod;
  }

  get deliverySlotStartTime(): Date {
    return new Date(this.currentOrder?.deliverySlotStartTime!!);

  }

  get deliverySlotEndTime(): Date {
    return new Date(this.currentOrder?.deliverySlotEndTime!!);
  }

  get deliveryMethod() {
    return this.currentOrder?.deliveryMethod;
  }

  get itemTotal() {
    return PriceFormatter.formatPrice(this.currentOrder?.totalItemPrice ?? new Big(0)) + ' €';
  }

  get depositTotal() {
    return PriceFormatter.formatPrice(this.currentOrder?.totalDeposit ?? new Big(0)) + ' €';
  }

  get shippingFee() {
    return PriceFormatter.formatPrice(this.currentOrder?.shippingFee ?? new Big(0)) + ' €';
  }

  get cartTotal() {
    return PriceFormatter.formatPrice(this.currentOrder?.totalPrice ?? new Big(0)) + ' €';
  }

  get discountTotal() {
    return PriceFormatter.formatPrice(this.currentOrder?.totalDiscount ?? new Big(0)) + ' €';
  }

  get hasDiscount() {
    return this.currentOrder?.totalDiscount && this.currentOrder.totalDiscount > 0;
  }

  get hasCouponDiscount(): boolean {
    return !!this.currentOrder?.couponDiscount && this.currentOrder.couponDiscount > 0;
  }

  get couponDiscountString(): string | undefined {
    if (this.hasCouponDiscount) {
      return '-' + PriceFormatter.formatPrice(this.currentOrder?.couponDiscount ?? new Big(0)) + ' €';
    }
    return undefined;
  }

  public routeBack() {
    this.$router.push({name: Routes.UserOrders});
  }
}
